import AjaxClass from './Validation/ajaxClass';
import FormValidate from './Validation/formValidateClass';
import MessageHandler from './Validation/messageHandler';

export default function forms() {
    document.querySelectorAll('[form]').forEach(formElement => {
        // Forms .needs-validation são tratados pelo bootstrapForms() (main.js);
        // ligar aqui também gera envio duplicado no mesmo clique.
        if (formElement.classList.contains('needs-validation')) {
            return;
        }
        formElement.addEventListener('submit', function (e) {
            e.preventDefault();
            const Loader = document.getElementById("loading-forms");
    
            let form = this;
            let fields = Array.from(new FormData(form).entries()).map(([name, value]) => ({ name, value }));
            let validation = new FormValidate(fields, 1, form.id);
    
            let images = form.querySelectorAll('input[type=file]');
            if (images.length > 0) {
                images.forEach(e => {
                    let image = { name: e.name, value: e.files[0] };
                    fields.push(image);
                });
            }
    
            let selects = form.querySelectorAll(`#${form.id} select`);
            selects.forEach(element => {
                if (!element.disabled) {
                    let select = {
                        name: element.name,
                        value: element.value || '',
                    };
                    fields.splice(fields.length - 1, 0, select);
                }
            });
    
            validation.validateAll(fields);
            let error = validation.hasError();
    
            MessageHandler.removeAllFormFailMessages();
    
            if (error) {
                let errorMessageId = validation.getErrorId();
                MessageHandler.showFailMessage(form.id, errorMessageId, false);
                return false;
            }
    
            let terms = form.querySelectorAll("input[type='checkbox']");
            if (terms.length > 0) {
                let unchecked = Array.from(terms).filter(term => !term.checked);
                if (!error && unchecked.length > 0) {
                    error = true;
                    MessageHandler.showFailMessage(form.id, unchecked[0].id, false);
                    // Checkbox sem id/name (ex.: form de simulação) não é achado pelo
                    // MessageHandler; marca o container direto para exibir o erro.
                    unchecked[0].parentElement.classList.add("show--error");
                    return false;
                }
            }
    
            if (!error) {
                if (form.disabled === true) {
                    return false;
                }

                const submitButton = form.querySelector('[type="submit"]');
                // O POST só sai depois do token do reCAPTCHA voltar, então trava
                // o botão de fato — não dá pra contar só com o overlay do loader.
                const lockForm = () => {
                    Loader.classList.add("open-modal");
                    form.disabled = true;
                    if (submitButton) submitButton.disabled = true;
                };
                const releaseForm = () => {
                    Loader.classList.remove("open-modal");
                    form.disabled = false;
                    if (submitButton) submitButton.disabled = false;
                };

                // O input mantém a máscara com "." na tela; para o envio (e para o
                // que o GTM captura no submit) o valor precisa ir só com números.
                const phoneField = form.querySelector('[phone]');
                const maskedPhoneValue = phoneField ? phoneField.value : null;
                if (phoneField) {
                    phoneField.value = phoneField.value.replace(/\D/g, '');
                }

                let formData = new FormData(form);
                if (phoneField) {
                    phoneField.value = maskedPhoneValue;
                }
                if (images.length > 0) {
                    fields.forEach(obj => {
                        if (!obj.value) obj.value = '';
                        formData.append(obj.name, obj.value);
                    });
                }

                // Depois do FormData: um botão desabilitado sairia do payload.
                lockForm();

                let type = 'POST';
                let url = form.action;
                let dataType = 'json';
    
                const modalSuccess = document.getElementById('success-message-forms');
                const modalSuccessDescription = document.querySelector('#success-message-forms .description');
                const modalError = document.getElementById('error-message-forms');
                const modalDescription = document.querySelector('#error-message-forms .description');
    
                class Contact extends AjaxClass {
                    successFunction(data, form) {
                        if (data.status === true) {
                            if (data.redirect) {
                                // Segue travado até a navegação concluir: liberar aqui
                                // deixa o form clicável durante o carregamento da página.
                                window.location = data.redirect;
                                return;
                            }

                            form.reset();
                            releaseForm();
                            modalSuccess.classList.add("open-modal");
                            modalSuccessDescription.innerHTML = data.txt;
                            return;
                        }

                        releaseForm();
                        modalDescription.innerHTML = data.txt;
                        modalError.classList.add("open-modal");
                    }

                    errorFunction(xhr, textStatus, errorThrown) {
                        releaseForm();
                        modalDescription.innerHTML = "Ocorreu um erro. Tente novamente mais tarde.";

                        if (errorThrown === 'Too Many Requests' || xhr.responseText === 'Too Many Requests') {
                            modalDescription.innerHTML = "Muitas tentativas! Aguarde um minuto antes de tentar novamente.";
                        }

                        modalError.classList.add("open-modal");
                    }
                }
    
                let ajax = new Contact(form, type, url, dataType, formData);
                ajax.send();
            }
    
            return false;
        });
    });
    
    document.querySelectorAll('[phone]').forEach(phoneElement => {
        phoneElement.addEventListener('keypress', function (event) {
            const charCode = event.which || event.keyCode;
    
            if ([8, 46, 9, 27, 13, 35, 36, 37, 39].includes(charCode) || (charCode === 190 && !this.value.includes('.'))) {
                return;
            }
    
            if (charCode < 48 || charCode > 57) {
                event.preventDefault();
            }
        });
    
        phoneElement.addEventListener('blur', function () {
            mascaraDeTelefone(this);
        });
    
        phoneElement.addEventListener('focus', function () {
            tiraHifen(this);
        });
    });
    
    function mascaraDeTelefone(telefone) {
        const textoAtual = telefone.value.replace(/[^0-9]/g, '');
        const isCelular = textoAtual.length >= 11;
        let textoAjustado;
    
        if (isCelular) {
            const parte1 = textoAtual.slice(0, 2);
            const parte2 = textoAtual.slice(2, 4);
            const parte3 = textoAtual.slice(4, 9);
            const parte4 = textoAtual.slice(9, 13);
    
            textoAjustado = `+${parte1} (${parte2}) ${parte3}${parte4 ? '.' + parte4 : ''}`;
        } else {
            const parte1 = textoAtual.slice(0, 2);
            const parte2 = textoAtual.slice(2, 4);
            const parte3 = textoAtual.slice(4, 8);
            const parte4 = textoAtual.slice(8, 12);
    
            textoAjustado = `+${parte1} (${parte2}) ${parte3}${parte4 ? '.' + parte4 : ''}`;
        }
    
        telefone.value = textoAjustado || null;
    }
    
    function tiraHifen(telefone) {
        telefone.value = telefone.value.replace(/\./g, '');
    }
    
}